import { setBooks } from "../actions"

const getBooks = async (dispatch) => {
    const response = await fetch("http://localhost:9000/books")
    const books = await response.json()
    dispatch(setBooks(books))
}
export default getBooks;